import { SearchFilter } from "./FilterSearchField";

export const setFiltersToLocalStorage = (
  filters: SearchFilter[],
  key: string,
) => {
  localStorage.setItem(key, JSON.stringify(filters));
};

export const setQuickFilterToLocalStorage = <T>(quickFilter: T, key: string) =>
  localStorage.setItem(key, quickFilter as unknown as string);

export const removeQuickFilterFromLocalStorage = (key: string) =>
  localStorage.removeItem(key);
